import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LegalStuff/legalStuff__nl-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;
export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout },
  seo: {
    ...sharedConfig['nl-NL'].seo,
    title: 'Juridische Informatie | Voorwaarden en beleid Lemonade Nederland',
    metaTitle: 'Juridische Informatie | Voorwaarden en beleid Lemonade Nederland',
    description:
      'Vind alle juridische documenten, belangrijke informatie en beleidsdetails over Lemonade’s verzekeringen en regelgeving in Nederland.',
  },
  MDXContent: content as DocumentTypes,
};
